/* eslint-disable import/order */
import combineActionHandlers from "@web-monorepo/infra/combineActionHandlers";
import { InstallReducer } from "@web-monorepo/shared/podInfra";
import { Saga } from "redux-saga";

if (global.navigator) {
  import("webrtc-adapter/out/adapter");
}

import {
  requestPermission,
  requestPermissionSaga,
  microphoneRequestPermissionHandler,
  microphonePermissionAllowedHandler,
  microphonePermissionDeniedHandler,
  microphoneNoMicrophoneHandler,
  microphoneWaitingOnUserHandler,
  MICROPHONE_INIT_LAG,
} from "./data/requestPermission";

export { requestPermission, MICROPHONE_INIT_LAG };

const STATE_KEY = "microphonePermissions";

export type MicrophoneState = {
  hasMicrophone: boolean | null;
  hasPermission: boolean | null;
  isRequestingPermission: boolean;
  isWaitingOnUser: boolean;
};

const initialState = {
  hasMicrophone: null, // null = unknown
  hasPermission: null, // null = unknown
  isRequestingPermission: false,
  isWaitingOnUser: false,
};

type State = {
  [STATE_KEY]: MicrophoneState;
};

export const selectState = (state: State) => state[STATE_KEY];
export const selectHasPermission = (state: State) => state[STATE_KEY].hasPermission;

const reducer = combineActionHandlers(initialState, [
  microphoneRequestPermissionHandler,
  microphonePermissionAllowedHandler,
  microphonePermissionDeniedHandler,
  microphoneNoMicrophoneHandler,
  microphoneWaitingOnUserHandler,
]);

export default function installer(installReducer: InstallReducer, installSaga: (saga: Saga) => void) {
  installReducer(STATE_KEY, reducer);
  installSaga(requestPermissionSaga);
}
